import { create } from "zustand";
import {
  getDailyAttendance,
  getAttendanceSummary,
  getDailyTrackerCounts,
  getAbsentEmployees,
  getDailyUpdatesFeed,
  getDailyUpdatesByDate
} from "@/services/HrService/DailyTrackerService";

const useDailyTrackerStore = create((set, get) => ({
  attendance: null,
  attendanceSummary: null,
  trackerCounts: null,
  absentEmployees: null,
  dailyUpdatesFeed: null,
  dailyUpdatesByDate: null,
  loading: false,
  error: null,
  selectedDate: new Date().toISOString().split('T')[0],

  // Set selected date
  setSelectedDate: (date) => {
    set({ selectedDate: date });
  },

  // Fetch daily attendance
  fetchDailyAttendance: async (date) => {
    try {
      set({ loading: true, error: null });
      const targetDate = date || get().selectedDate;
      
      const response = await getDailyAttendance(targetDate);
      console.log("Daily Attendance API Response:", response);
      
      if (response.success) {
        set({ attendance: response.data, loading: false });
      } else {
        set({ error: response.error?.message || 'Failed to fetch attendance', loading: false });
      }
    } catch (error) {
      console.error("Fetch Daily Attendance Error:", error);
      set({ error: error.message, loading: false });
      throw error;
    }
  },


  // Fetch attendance summary
  fetchAttendanceSummary: async (date) => {
    try {
      const targetDate = date || get().selectedDate;
      const response = await getAttendanceSummary(targetDate);
      console.log("Attendance Summary API Response:", response);

      if (response.success) {
        set({ attendanceSummary: response.data });
      } else {
        set({ error: response.error?.message || 'Failed to fetch attendance summary' });
      }
    } catch (error) {
      console.error("Fetch Attendance Summary Error:", error);
      set({ error: error.message });
      throw error;
    }
  },

  // Fetch daily tracker counts
  fetchDailyTrackerCounts: async (date) => {
    try {
      const targetDate = date || get().selectedDate;
      const response = await getDailyTrackerCounts(targetDate);
      console.log("Daily Tracker Counts API Response:", response);

      if (response.success) {
        set({ trackerCounts: response.data });
      } else {
        set({ error: response.error?.message || 'Failed to fetch tracker counts' });
      }
    } catch (error) {
      console.error("Fetch Daily Tracker Counts Error:", error);
      set({ error: error.message });
      throw error;
    }
  },

  // Fetch absent employees
  fetchAbsentEmployees: async (date) => {
    try {
      const targetDate = date || get().selectedDate;
      const response = await getAbsentEmployees(targetDate);
      console.log("Absent Employees API Response:", response);

      if (response.success) {
        set({ absentEmployees: response.data });
      } else {
        set({ error: response.error?.message || 'Failed to fetch absent employees' });
      }
    } catch (error) {
      console.error("Fetch Absent Employees Error:", error);
      set({ error: error.message });
      throw error;
    }
  },

  // Fetch daily updates feed
  fetchDailyUpdatesFeed: async (limit = 50) => {
    try {
      set({ loading: true, error: null });
      const response = await getDailyUpdatesFeed(limit);
      console.log("Daily Updates Feed API Response:", response);

      if (response.success) {
        set({ dailyUpdatesFeed: response.data, loading: false });
      } else {
        set({ error: response.error?.message || 'Failed to fetch daily updates feed', loading: false });
      }
    } catch (error) {
      console.error("Fetch Daily Updates Feed Error:", error);
      set({ error: error.message, loading: false });
      throw error;
    }
  },

  // Fetch daily updates by date
  fetchDailyUpdatesByDate: async (date) => {
    try {
      set({ loading: true, error: null });
      const targetDate = date || get().selectedDate;
      const response = await getDailyUpdatesByDate(targetDate);
      console.log("Daily Updates By Date API Response:", response);

      if (response.success) {
        set({ dailyUpdatesByDate: response.data, loading: false });
      } else {
        set({ error: response.error?.message || 'Failed to fetch daily updates by date', loading: false });
      }
    } catch (error) {
      console.error("Fetch Daily Updates By Date Error:", error);
      set({ error: error.message, loading: false });
      throw error;
    }
  },

  // Reset errors
  resetErrors: () => set({ error: null }),
}));

export default useDailyTrackerStore;